import { EventType } from "@/types";

export const eventTypes: { value: EventType; label: string }[] = [
  { value: "race", label: "Race" },
  { value: "practice", label: "Practice" },
  { value: "trackday", label: "Track Day" },
  { value: "time_attack", label: "Time Attack" },
  { value: "target_time_attack", label: "Target Time Attack" },
  { value: "drift", label: "Drift" },
  { value: "endurance", label: "Endurance" },
  { value: "gymkhana", label: "Gymkhana" },
  { value: "autocross", label: "Autocross" },
  { value: "simracing", label: "Sim Racing" },
  { value: "other", label: "Other" },
];
